import { Box, Container, Stack, Typography } from '@mui/material';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { Link as RouterLink } from 'react-router-dom';
import { brand } from '@/theme/theme';
import logoUrl from '@/assets/ardinotech-logo.png';

export interface LegalSection {
  heading: string;
  body?: string[];
  bullets?: string[];
}

interface LegalLayoutProps {
  title: string;
  effectiveDate: string;
  intro: string[];
  sections: LegalSection[];
}

export function LegalLayout({ title, effectiveDate, intro, sections }: LegalLayoutProps) {
  return (
    <Box sx={{ minHeight: '100vh', background: brand.meshFrom }}>
      <Box sx={{ borderBottom: `1px solid #E5E7EB`, bgcolor: '#fff' }}>
        <Container maxWidth="md" sx={{ py: 2 }}>
          <Stack direction="row" alignItems="center" justifyContent="space-between">
            <Stack direction="row" alignItems="center" spacing={1.5}>
              <Box component="img" src={logoUrl} alt="Ardinotech" sx={{ height: 36 }} />
            </Stack>
            <RouterLink
              to="/"
              style={{ display: 'flex', alignItems: 'center', gap: 6, color: brand.violet, textDecoration: 'none', fontSize: 14, fontWeight: 600 }}
            >
              <ArrowBackIcon fontSize="small" /> Back to home
            </RouterLink>
          </Stack>
        </Container>
      </Box>

      <Container maxWidth="md" sx={{ py: { xs: 4, md: 6 } }}>
        <Typography variant="h1" sx={{ fontSize: { xs: 26, md: 32 }, fontWeight: 800, color: brand.navy, mb: 0.5 }}>
          {title}
        </Typography>
        <Typography sx={{ color: brand.inkSoft, fontSize: 13, mb: 3 }}>
          Effective date: {effectiveDate} &nbsp;·&nbsp; Ardinotech Private Limited
        </Typography>

        {intro.map((p, i) => (
          <Typography key={i} sx={{ color: brand.ink, lineHeight: 1.75, mb: 2, fontSize: 14.5 }}>
            {p}
          </Typography>
        ))}

        {sections.map((s, i) => (
          <Box key={i} sx={{ mb: 3.5 }}>
            <Typography sx={{ fontWeight: 700, color: brand.navy, fontSize: 17, mb: 1 }}>
              {i + 1}. {s.heading}
            </Typography>
            {s.body?.map((p, j) => (
              <Typography key={j} sx={{ color: brand.ink, lineHeight: 1.75, mb: 1.25, fontSize: 14.5 }}>
                {p}
              </Typography>
            ))}
            {s.bullets && (
              <Box component="ul" sx={{ m: 0, pl: 3 }}>
                {s.bullets.map((b, j) => (
                  <Typography key={j} component="li" sx={{ color: brand.ink, lineHeight: 1.75, mb: 0.75, fontSize: 14.5 }}>
                    {b}
                  </Typography>
                ))}
              </Box>
            )}
          </Box>
        ))}

        <Box sx={{ mt: 5, pt: 3, borderTop: `1px solid ${brand.glassBorder}` }}>
          <Typography sx={{ fontSize: 12, color: brand.inkSoft }}>
            © {new Date().getFullYear()} Ardinotech Private Limited. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}
